import React, { Fragment, useEffect, useState } from "react";
import {
  Box,
  Typography,
  Button,
  Skeleton,
  Stack,
  Chip,
  Modal,
  useMediaQuery,
  CardMedia,
  Card,
} from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import { useSelector } from "react-redux";
import DiscountRibbon from "../../../assets/99giftimages/Card Discount Icon-1-01.svg";
import ProductDetailAccordion from "./productDetailAccordion";
import { getHighestDiscount } from "../../../hooks/utilsFn/utilsFn";
import { renderHTML } from "../../../hooks/utilsFn/utilsFn";

const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",

  width: {
    xs: "92%",
    sm: "80%",
    md: "70%",
  },

  maxHeight: {
    xs: "70vh",
    sm: "80vh",
  },

  overflowY: {
    xs: "auto",
    sm: "visible",
  },

  boxShadow: 24,
  p: { xs: 2, sm: 4 },
  borderRadius: 2,
  background: "#F9F2F0",
  fontFamily: "Be Vietnam Pro",
};

const ProductImageComponent = ({ logoUrl, altText, discount, symbol }) => (
  <Box
    sx={{
      width: "100%",
      display: "flex",
      justifyContent: {
        xs: "center",
        md: "flex-start",
      },
      alignItems: "center",
      position: "relative",

      mt: {
        xs: 1,
        md: 2,
      },

      overflow: "visible",
    }}
  >
    <Card
      sx={{
        position: "relative",

        width: {
          xs: "100%",
          sm: 300,
          md: 350,
          lg: 420,
          xl: 450,
        },

        height: {
          xs: 200,
          sm: 200,
          md: 260,
          lg: 280,
          xl: 300,
        },

        maxWidth: "450px",
        maxHeight: "300px",

        borderRadius: "20px",

        overflow: "visible",

        background: "#fff",

        boxShadow: "0 6px 24px rgba(0,0,0,0.10)",

        transition: "all 0.3s ease",

        "&:hover": {
          transform: "translateY(-5px)",
          boxShadow: "0 10px 28px rgba(0,0,0,0.15)",
        },
      }}
    >
      {/* RIBBON */}
      {discount !== undefined && (
        <Box
          sx={{
            position: "absolute",

            top: {
              xs: -30,
              sm: -35,
              md: -40,
              lg: -45,
            },

            left: {
              xs: -27,
              sm: -31,
              md: -35,
              lg: -38,
            },

            width: {
              xs: 120,
              sm: 140,
              md: 160,
              lg: 170,
            },

            zIndex: 999,
            pointerEvents: "none",
          }}
        >
          <Box
            component="img"
            src={DiscountRibbon}
            alt="discount"
            sx={{
              width: "100%",
              height: "100%",
              objectFit: "contain",
            }}
          />

          {/* TEXT */}
          <Typography
            sx={{
              position: "absolute",

              top: {
                xs: 30,
                sm: 36,
                md: 41,
                lg: 44,
              },

              left: 0,

              width: "100%",
              textAlign: "center",
              color: "#f1d08d",
              fontWeight: 700,
              fontSize: {
                xs: "10px",
                sm: "11px",
                md: "12.5px",
                lg: "13px",
              },

              fontFamily: "Be Vietnam Pro",
              lineHeight: 1,
            }}
          >
            Save : {discount != null ? `${discount} ${symbol}` : "N/A"}
          </Typography>
        </Box>
      )}

      {/* IMAGE */}
      <CardMedia
        component="img"
        image={logoUrl}
        alt={altText}
        sx={{
          width: "100%",
          height: "100%",
          borderRadius: "20px",
          objectFit: "cover",
        }}
      />
    </Card>
  </Box>
);

const StatusChip = ({ label, active }) => (
  <Chip
    icon={
      active ? (
        <CheckCircleIcon sx={{ fontSize: "15px", color: "#2ab638 !important" }} />
      ) : (
        <CancelIcon sx={{ fontSize: "15px", color: "#ea0c0c !important" }} />
      )
    }
    label={label}
    sx={{
      color: active ? "#0fab22" : "#ff2121",
      background: "none",
      fontWeight: 600,
      fontFamily: "Be Vietnam Pro",
      "& .MuiChip-label": {
        fontSize: {
          xs: "10px",
          sm: "10px",
          md: "12px",
          lg: "12.2px",
          xl: "12.5px",
        },
        px: { lg: 1, xl: 1 },
      },

      "& .MuiSvgIcon-root": {
        fontSize: {
          lg: 10,
          xl: 13,
        },
      },
    }}
  />
);

export const RedeemTypeChip = ({ type }) => {
  const v = type?.toUpperCase();
  return (
    <Stack direction="row" spacing={{ xs: 0, sm: 0, md: 0 }} >
      <StatusChip label="Online" active={v === "ONLINE" || v === "BOTH"} />
      <StatusChip
        label="Store"
        active={v === "IN_STORE" || v === "OFFLINE" || v === "BOTH"}
      />
    </Stack>
  );
};

const ProductDetailCard = ({ pageLoading }) => {
  const PRODUCTDETAILS = useSelector((state) => state?.ProductDetail?.allData);

  const userDiscounts = PRODUCTDETAILS?.denominations
    ?.flatMap(item => item?.userProductDenominationDiscounts || [])
    ?.map(item => Number(item.discountValue))
    ?.filter(value => !isNaN(value));

  const Discount =
    userDiscounts?.length > 0
      ? Math.max(...userDiscounts)
      : getHighestDiscount(PRODUCTDETAILS?.denominations);

  const [open, setOpen] = useState(false);
  const [isExpanded, setIsExpanded] = useState(false);
  const [characterNo, setCharacterNo] = useState(540);
  const lgDevices = useMediaQuery("(min-width:900px)");
  const isMobile = useMediaQuery("(max-width:600px)");

  const DiscountType = PRODUCTDETAILS?.denominations?.[0]?.cashbackOrDiscount
  const symbol = DiscountType === "CASHBACK" ? "%" : "%"


  useEffect(() => {

    if (isMobile) {
      setCharacterNo(180);
    } else if (lgDevices) {
      setCharacterNo(400);
    } else {
      setCharacterNo(300);
    }
  }, [lgDevices, isMobile]);

  function getDisplayDescription(description) {
    if (!description) return "";

    if (isExpanded) {
      return description;
    }

    // Different truncation for mobile
    if (isMobile) {
      // Show only 2-3 lines on mobile
      const words = description.split(' ');
      if (words.length > 30) {
        return words?.slice(0, 30).join(' ') + '...';
      }
      return description;
    }

    // Desktop truncation
    if (description?.length > characterNo) {
      return description?.slice(0, characterNo) + "...";
    }
    return description;
  }

  const shouldShowMore = () => {
    const description = PRODUCTDETAILS?.description;
    if (!description) return false;

    if (isMobile) {
      const words = description.split(' ');
      return words.length > 30;
    }
    return description.length > characterNo;
  };

  const handleShowMoreToggle = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <Fragment>
      <Box
        sx={{
          maxWidth: "100%",
          width: "100%",
          display: "flex",
          alignItems: "flex-start",
          flexDirection: "column",
          rowGap: 1.5,
        }}
      >
        {/* Product Name */}
        {!pageLoading ? (
          <Typography
            variant="h1"
            sx={{
              mt: { xs: 0, md: 2 },
              fontSize: { xs: "1.6rem", md: "1.8rem", lg: "2.2rem" },
              color: "primary.main",
              fontWeight: 600,
              fontFamily: "Onest",
              textTransform: "capitalize",

              lineHeight: {
                xs: 1.337,
              },
            }}
          >
            {PRODUCTDETAILS?.name}
          </Typography>
        ) : (
          <Skeleton variant="text" sx={{ fontSize: "2rem" }} />
        )}

        {/* Image */}
        {!pageLoading ? (
          <ProductImageComponent
            logoUrl={
              PRODUCTDETAILS?.productImages?.[0]?.url || PRODUCTDETAILS?.brand?.logo
            }
            altText={PRODUCTDETAILS?.name}
            discount={Discount}
            symbol={symbol}
          />
        ) : (
          <Skeleton variant="rounded" height={220} />
        )}



        {/* Redeem Box */}
        {!pageLoading ? (
          <Box
            sx={{
              width: { xs :"100%", sm: "100%", md: 350, lg: 450,  },
              height: { sm: 20, md: 13, lg: 15 },

              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: 1,
                mt: { sm: 1, md: 3, lg: 3 },
                border: "1.8px solid #E4C18F",
                borderRadius: "6px",
                px: 1.5,
                mb: { sm: 1, md: 0, lg: 1 },

              }}
            >
              <Typography
                sx={{
                  fontSize: {
                    xs: "11px",
                    md: "12.5px",
                    lg: "13px",
                  },
                  fontWeight: 600,
                  fontFamily: "Be Vietnam Pro",
                }}
              >
                Redeem At :
              </Typography>

              <RedeemTypeChip type={PRODUCTDETAILS?.usageLocation} />
            </Box>
          </Box>
        ) : (
          <Skeleton height={40} />
        )}

        {/* Description - Enhanced for Mobile */}
        {!pageLoading ? (
          <Box sx={{ mt: { xs: 0, md: 2 }, display: "block" }}>
            <Typography
              variant="body1"
              sx={{
                width: "100%",
                maxWidth: {
                  xs: "100%",
                  md: "400px",
                  lg: "500px",
                },
                fontSize: {
                  xs: "1.0125rem",
                  sm: "1.1rem",
                  lg: "1.2rem"
                },
                color: "#000000",
                fontFamily: "Be Vietnam Pro",
                wordBreak: "break-word",
                whiteSpace: "pre-wrap",
                textAlign: "left",
                lineHeight: {
                  xs: 1.7,
                  md: 1.8
                },
                // For mobile: limit to 3 lines with ellipsis
                ...(isMobile && !isExpanded && {
                  display: '-webkit-box',
                  WebkitLineClamp: {
                    xs: 3,
                    lg: 4
                  },
                  WebkitBoxOrient: 'vertical',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                }),
              }}
            >
              {renderHTML(getDisplayDescription(PRODUCTDETAILS?.description))}
            </Typography>
            {shouldShowMore() && (
              <Box
                onClick={handleShowMoreToggle}
                sx={{
                  display: "inline-flex",
                  cursor: "pointer",
                  color: "primary.main",
                  fontWeight: 500,
                  fontSize: {
                    xs: "12px",
                    sm: "13px",
                    md: "14px"
                  },
                  fontFamily: "Be Vietnam Pro",
                  '&:hover': {
                    textDecoration: "underline",
                    opacity: 0.9
                  }
                }}
              >
                {isExpanded ? "Show Less" : "Show More"}
              </Box>
            )}
          </Box>
        ) : (
          <Skeleton height={30} />
        )}

        {/* product accordion component */}
        <Box
          sx={{
            width: "100%",
          }}
        >
          <ProductDetailAccordion />
        </Box>
      </Box>

      {/* Modal - Keep for desktop fallback but can be removed if not needed */}
      <Modal open={open} onClose={() => setOpen(false)}>
        <Box sx={modalStyle}>
          <Typography variant="h5">{PRODUCTDETAILS?.name}</Typography>
          <Typography
            sx={{
              mt: 2,
              color: "white.main",
              fontSize: "14px",
              fontWeight: 500,
              wordSpacing: 1,
            }}
          >
            {PRODUCTDETAILS?.description}
          </Typography>
          <Button
            variant="contained"
            sx={{ mt: 3 }}
            onClick={() => setOpen(false)}
          >
            Close
          </Button>
        </Box>
      </Modal>
    </Fragment>
  );
};

export default ProductDetailCard;
